import React, { useState } from "react";
import { AlignLeft, CheckSquare, Clock, MoreHorizontal } from "react-feather";
import { formatDate } from "../Helper/Util";
// import { ICard } from "../../Interfaces/Kanban";
import Chip from "../../Common/Chip";
import Dropdown from "../../Dropdown/Dropdown";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import "./Card.css";
import CardInfo from "./CardInfo/CardInfo";
// interface CardProps {
//   card: ICard;
//   boardId: number;
//   removeCard: (boardId: number, cardId: number) => void;
//   onDragEnd: (boardId: number, cardId: number) => void;
//   onDragEnter: (boardId: number, cardId: number) => void;
//   updateCard: (boardId: number, cardId: number, card: ICard) => void;
// }
function Card(props) {
  const {
    card,
    boardId,
    removeCard,
    onDragEnd,
    onDragEnter,
    updateCard,
    boardMember,
  } = props;
  const { _id, title, desc, date, tasks, labels, assign, points, dueDate } = card;
  console.log("assign:", assign)
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      {showModal && (
        <CardInfo
          onClose={() => setShowModal(false)}
          card={card}
          boardId={boardId}
          updateCard={updateCard}
          boardMember={boardMember}
        />
      )}
      <div
        key={card._id}
        draggable="true"
        onDragEnd={() => onDragEnd(boardId, _id)}
        onDragEnter={() => onDragEnter(boardId, _id)}
      >
        <div className="card-col" onClick={() => setShowModal(true)}>
          <div className="card-top">
            <div className="card-top-labels">
              {labels?.map((item, index) => (
                <Chip key={index} item={item} />
              ))}
            </div>
            <div
              className="card-top-more"
              onClick={(event) => {
                event.stopPropagation();
                setShowDropdown(true);
              }}
            >
              <MoreHorizontal color="black" />
              {showDropdown && (
                <Dropdown

                  onClose={() => setShowDropdown(false)}
                >
                  <p className="board-dropdown" onClick={() => removeCard(boardId, _id)}>Delete Card</p>
                </Dropdown>
              )}
            </div>
          </div>
          <div className="card-title-col">{title}</div>
          <div>
            <p title={desc}>
              <AlignLeft />
            </p>
          </div>
          <div className="card-footer">
            {date && (
              <p className="card-footer-item">
                <Clock className="card-footer-icon" />
                {`${formatDate(date)}- ${formatDate(dueDate)} `}
              </p>
            )}
          </div>
          {card.files ? (
            <img src={
              `${process.env.REACT_APP_API_URL_IMG}/${card.files}`} alt="" className="card__image" />
          ) : (null)}


          <div className="footer__card_div">
            {tasks && tasks?.length > 0 && (
              <p className="card-footer-item">
                <CheckSquare className="card-footer-icon" />
                {tasks?.filter((item) => item.completed)?.length}/
                {tasks?.length}
              </p>
            )}
            {assign && assign?.length > 0 && (
              <div>
                {assign?.map((item, index) => (
                  <div className="card-email" key={index}>
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{item.email}</Tooltip>}>
                      {/* <p>{item?.email?.charAt(0)}</p> */}
                      {
                        item?.picture ? (
                          <img src={`${process.env.REACT_APP_API_URL_IMG}/${item.picture}`} alt='' className="p" />
                        ) : <p>{item?.email?.charAt(0)}</p>
                      }
                      {/* <img src={item?.profilePicture}   /> */}
                    </OverlayTrigger>
                  </div>
                ))}
              </div>
            )}
            <div>{points && <p className="card-point">{points}</p>}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
